<template>
  <div class="no-stock-popup-page">
    <div class="no-stock-popup">
        <div class="no-stock-header">
            <p class="no-stock-title">Uh Oh...</p>
            <p class="no-stock-subtitle">Something's out of stock</p>
        </div>
        <div class="order-details">
            <p class="order-title">OOS Details</p>
            <div class="no-stock-products-container">
                <div class="oos-product" :key="product.id" v-for="product in oosProducts">
                    <img :src="product | getProductImage">
                    <div>
                        <p class="oos-title">{{product.title}}</p>
                        <p v-if="product.variants" class="oos-price">{{product.variants[0].price | moneySaleFormat}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="replacements" class="quick-replacements">
            <p class="no-stock-details">Pick replacements</p>
            <VueSlickCarousel :infinite="true" :arrows="true" :slidesToShow="slidesToShow()" :slidesToScroll="slidesToShow()">
              <template #prevArrow="arrowOption">
                <div>
                  <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648">
                </div>
              </template>
              <li v-for="addonProduct in replacements" :key="addonProduct.id">
                <template></template>
                  <AddonProductNew :product="addonProduct" :cartProducts="selectedAddonProducts"/>
              </li>
              <template #nextArrow="arrowOption">
                <div>
                  <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648">
                </div>
              </template>
            </VueSlickCarousel>
        </div>
        <div class="actions">
            <button :disabled="!canReplace" @click="replaceAndBundle" class="happybox-button yellow">replace &amp; continue</button>
        </div>
        <div class="separator">
            <div class="line-separator"></div>
            <div class="text">OR</div>
            <div class="line-separator"></div>
        </div>
        <div class="actions bottom-actions">
            <button @click="removeAndContinue" class="happybox-button purple">remove items &amp; continue</button>
            <!-- <button @click="removeAndBack" class="happybox-button purple">go back</button> -->
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddonProductNew from './AddonProductNew.vue';
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  props:{
    oosProducts: Array,
    firstStateProducts: Array,
    fromSavedCart: Boolean,
    fromCurated: Boolean,
  },
  components: {
    VueSlickCarousel,
    AddonProductNew
  },
  data(){
    return {}
  },
  computed:{
    ...mapGetters([
      'addonProducts',
      'selectedAddonProducts',
      'boxQty'
    ]),
    itemsWithStock(){
      return this.selectedAddonProducts.filter((item) => {
        return !this.oosProducts.some(i => i.id === item.id) && item.id != 5857068220581 && item.quantity > 0;
      })
    },
    replacements(){
      var oosIds = this.oosProducts.map(x => x.id);
      let replacements = this.addonProducts.filter(x => !oosIds.includes(x.id) && x.variants.length < 2 && x.variants[0].inventory_quantity >= this.boxQty);
      let oosCategories = this.oosProducts.filter(x => x.tags).flatMap(x => x.tags);
      if(oosCategories.length > 0){
        oosCategories = oosCategories.filter(x => x.includes("Category"));
        replacements = replacements.filter(x => x.tags.some(y => oosCategories.includes(y)));
      }

      return replacements;
    },
    canReplace(){
      return JSON.stringify(this.selectedAddonProducts) != JSON.stringify(this.firstStateProducts);
    }
  },
  methods:{
    slidesToShow() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768) {
        return 1;
      } else {
        return 3;
      }
    },
    removeItems(){
      let previousSelectedAddons = this.firstStateProducts.filter((item) => {
        return !this.oosProducts.some(i => i.id === item.id) && item.id != 5857068220581 && item.quantity > 0;
      })
      this.$store.commit('updateAllSelectedAddonProducts', previousSelectedAddons);
    },
    replaceAndBundle(){
      if(this.canReplace)
        this.continue();
    },
    removeAndContinue(){
      this.removeItems();
      this.continue();
    },
    continue(){
        if(this.fromSavedCart){
            this.$emit("continuesaved");
        }
        else {
            this.$emit("continuecurated");
        }
    },
    removeAndBack(){
        this.removeItems(); 
        this.$emit("goback");
    }
  }
}
</script>

<style scoped>
  .no-stock-popup-page{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 43;
  }

  .no-stock-popup{
    background-color: white;
    width: 60%;
    height: 95%;
    overflow-y: auto;
    padding: 3%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .no-stock-header{
    box-shadow: inset 0px -1px 0px #e6e8ec;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .no-stock-title{
    font-family: 'moret';
    font-size: 4vw;
    font-weight: bold;
    line-height: 1;
  }
  .no-stock-subtitle{
    font-family: 'moret';
    font-size: 2.5vw;
    font-weight: 300;
  }

  .no-stock-wiggle{
    margin-left: auto;
    margin-right: auto;
    display: inline-block;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .no-stock-details{
    color: #150131;
    font-size: 1.8vw;
    font-weight: 700;
    display: inline-block;
    margin-bottom: 2px;
    letter-spacing: 1px;
  }

  .order-details{
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-bottom: 30px;
    padding-top: 30px;
  }

  .order-details .order-title{
    font-size: 1.8vw;
    font-weight: bold;
  }

  .no-stock-products-container{
    display: flex;
    align-items: flex-start;
    width: 100%;
    flex-direction: column;
  }

  .oos-product{
    display: flex;
    align-items: flex-start;
    width: 100%;
  }

  .oos-product div{
    width: 66%;
    padding-left: 5%;
  }

  .oos-product img{
    width: 33%;
  }

  .oos-product .oos-title{
    font-size: 1.3vw;
    font-weight: bold;
    white-space: nowrap;
  }

  .oos-price{
    font-size: 1.3vw;
  }

  .quick-replacements{
    padding-top: 30px;
    width: 100%;
  }

  .quick-replacements li{
    padding: 5%;
  }

  .separator{
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: 100%;
  }

  .line-separator{
    height: 0px;
    border-top: 1px solid black;
    width: 40%;
  }

  .separator .text{
    font-size: 26px!important;
    letter-spacing: 1px;
    font-weight: 700;
    color: #150131;
    margin-bottom: 2px;
    position: relative;
    display: block;
    background: white;
    width: fit-content;
    padding: 0% 5%;
  }

  .actions{
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }

  .happybox-button.yellow{
    width: 100%;
  }

  .happybox-button.purple{
    width: 100%;
    background-color: #e6d7fa;
    color: #000;
    font-weight: 600;
  }

  .happybox-button.purple:hover{
    background-color: #baa5e5;
  }

  .slick-prev:before, .slick-next:before {
    font-weight: bold;
    color: black;
    font-family: unset;
  }

  .left-arrow {
    background-color: #150131;
    mask: url(https://cdn.shopify.com/s/files/1/1363/8433/files/Back.svg?v=1616510406);
    height: 21px;
    width: 13px;
  }

  .right-arrow{
    background-color: #150131;
    mask: url(https://cdn.shopify.com/s/files/1/1363/8433/files/Forward.svg?v=1616510406);
    height: 21px;
    width: 13px;
  }

  .slick-next:before,.slick-prev:before{
    content: ""!important;
  }

  .slick-prev img, .slick-next img{
    width: 100%;
  }

    .happybox-button.purple{
        margin-bottom: 5%;
    }   

  @media screen and (max-width: 767px) {
    .no-stock-popup{
        width: 100%;
        height: 100%;
    }

    .no-stock-title{
        font-size: 8vw;
    }

    .order-details .order-title{
        font-size: 5vw;
    }

    .oos-product .oos-title,.oos-product .oos-price{
        font-size: 3.5vw;
    }

    .no-stock-subtitle,.no-stock-details{
        font-size: 5vw;
    }

    .happybox-button.purple{
        margin-bottom: 5%;
    }

    .slick-prev, .slick-next{
        width: 8vw;
        z-index: 1;
        top: 37%;
    }

    .slick-next{
        right: 0px;
    }

    .slick-prev{
        left: 0px;
    }

    .quick-replacements li{
      padding: 10%;
    }
  }
</style>